import { FormProvider } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from "moment";

import ProstateReferralImage from "assets/images/prostateReferral.png";
import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";

import { scrollToFirstError } from "../../utils/scrollToFirstError";
import { ItemFormWrapper } from "../ItemFormWrapper/ItemFormWrapper";
import { CurrentMedicationSection } from "./CurrentMedicationSection";
import style from "./ProstateAdditionalInfoForm.module.css";
import { ProstatePrevField } from "./ProstatePrevField";
import { PsaFormItem } from "./PsaFormItem";

export const ProstateAdditionalInfoForm = ({
  onBack,
  onContinue,
  form,
  data,
  latestPsaResult,
}) => {
  const handleFormSubmit = (values) => {
    onContinue(values);
  };

  const hasSeenUrologist = form.watch("hasSeenUrologist");

  return (
    <>
      <img
        src={ProstateReferralImage}
        alt="national rapid access prostate clinic referral form"
      />
      <ItemFormWrapper
        onBack={onBack}
        onContinue={form.handleSubmit(handleFormSubmit, scrollToFirstError)}
        bg="#ddf3ff"
        padding="0px"
      >
        <div
          className={style.inputGroupGrid5Columns}
          style={{ marginTop: "24px" }}
        >
          <div>
            <p className={style.referralFormLabel}>Patient Name</p>
            <p className={style.referralFormValue}>
              {data.firstName} {data.familyName}
            </p>
          </div>
          <div>
            <p className={style.referralFormLabel}>Gender</p>
            <p className={style.referralFormValue}>
              {data.gender
                ? data.gender.charAt(0).toUpperCase() +
                  data.gender.slice(1).toLowerCase()
                : ""}
            </p>
          </div>
          <div>
            <p className={style.referralFormLabel}>Date of Birth</p>
            <p className={style.referralFormValue}>{data.dateOfBirth}</p>
          </div>
          <div>
            <p className={style.referralFormLabel}>Receiving Site</p>
            <p className={style.referralFormValue}>{data.hospitalName}</p>
          </div>
          <div>
            <p className={style.referralFormLabel}>Referral Type</p>
            <p className={style.referralFormValue}>
              {" "}
              {data.referralType
                ? data.referralType.charAt(0).toUpperCase() +
                  data.referralType.slice(1).toLowerCase()
                : ""}
            </p>
          </div>
        </div>
        <div
          className={style.itemWrapper}
          style={{
            borderBottom: "none",
          }}
        >
          <FormProvider {...form}>
            <form
              className={style.addReferralForm}
              onSubmit={form.handleSubmit(handleFormSubmit, scrollToFirstError)}
              style={{ gap: "16px" }}
            >
              <FormField name="hasSeenUrologist">
                <div className={style.formItemWrapper}>
                  <label className={style.addReferralFormLabel}>
                    Prev. Seen by Urologist
                  </label>
                  <div style={{ color: "#F72924" }}>*</div>
                  <div style={{ display: "flex", gap: "12px" }}>
                    <div
                      className={style.winXpSelectWrapper}
                      style={{
                        minWidth: "100px",
                        gap: "12px",
                        alignItems: "center",
                      }}
                    >
                      <Select
                        name="hasSeenUrologist"
                        options={[
                          { label: "Yes", value: "yes" },
                          { label: "No", value: "no" },
                        ]}
                        value={form.watch("hasSeenUrologist")}
                        onChange={(value) => {
                          form.setValue("hasSeenUrologist", value);
                          if (value !== "yes") {

                          }
                        }}
                        style={{ minWidth: "300px" }}
                        required
                      />
                    </div>
                    <a
                      href="https://www.hse.ie/eng/services/list/5/cancer/profinfo/resources/gpreferrals/nccp-prostate-cancer-gp-referral-guideline.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={style.link}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        height: "28px",
                      }}
                    >
                      Prostate Referral Guidelines
                    </a>
                  </div>
                </div>
              </FormField>

              {hasSeenUrologist === "yes" && (
                <>
                  <div
                    className={style.formItemWrapper}
                    style={{ marginTop: "-4px" }}
                  >
                    <div></div>
                    <div></div>
                    <FormField name={"hasSeenUrologistConsultant"}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        <label
                          className={style.addReferralFormLabel}
                          style={{
                            width: "80px",
                            fontWeight: "400",
                            fontSize: "13px",
                          }}
                        >
                          Consultant
                        </label>
                        <input
                          className={style.winXpInputWrapper}
                          style={{ minWidth: "205px" }}
                          {...form.register("hasSeenUrologistConsultant")}
                        />
                      </div>
                    </FormField>
                  </div>
                  <div
                    className={style.formItemWrapper}
                    style={{ marginTop: "-4px" }}
                  >
                    <div></div>
                    <div></div>
                    <FormField name={"hasSeenUrologistLocations"}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        <label
                          className={style.addReferralFormLabel}
                          style={{
                            width: "80px",
                            fontWeight: "400",
                            fontSize: "13px",
                          }}
                        >
                          Location
                        </label>
                        <input
                          className={style.winXpInputWrapper}
                          style={{ minWidth: "205px" }}
                          {...form.register("hasSeenUrologistLocations")}
                        />
                      </div>
                    </FormField>
                  </div>
                  <div
                    className={style.formItemWrapper}
                    style={{ marginTop: "-4px" }}
                  >
                    <div></div>
                    <div></div>
                    <FormField name="dateOfUrologyConsult">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        <label
                          className={style.addReferralFormLabel}
                          style={{
                            width: "80px",
                            fontWeight: "400",
                            fontSize: "13px",
                          }}
                        >
                          Date
                        </label>
                        <div
                          className={`${style.addPregnancyDatePickerWrapper} ${style.winXpDatepickerWrapper}`}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              format="DD-MM-YYYY"
                              name="dateOfUrologyConsult"
                              value={
                                form.watch("dateOfUrologyConsult")
                                  ? dayjs(
                                      form.watch("dateOfUrologyConsult"),
                                      "DD-MM-YYYY"
                                    )
                                  : null
                              }
                              sx={{
                                width: "100%",
                                height: "36px",
                                minWidth: "205px",
                              }}
                              onChange={(newValue) => {
                                form.setValue(
                                  "dateOfUrologyConsult",
                                  newValue
                                    ? moment(new Date(dayjs(newValue))).format(
                                        "DD-MM-YYYY"
                                      )
                                    : null
                                );
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                    </FormField>
                  </div>
                </>
              )}

              <FormField name="digitalRectalExam">
                <div className={style.formItemWrapper}>
                  <label className={style.addReferralFormLabel}>
                    Digital Rectal Exam
                  </label>
                  <div></div>
                  <div className={style.winXpSelectWrapper}>
                    <Select
                      options={[
                        {
                          label: "DRE - Prostate feels benign",
                          value: "DRE - Prostate feels benign",
                        },
                        {
                          label: "DRE - Prostate feels suspicious",
                          value: "DRE - Prostate feels suspicious",
                        },
                      ]}
                      value={form.watch("digitalRectalExam")}
                      onChange={(value) =>
                        form.setValue("digitalRectalExam", value)
                      }
                      required
                    />
                  </div>
                </div>
              </FormField>

              <FormField name="otherClinicalExam">
                <div className={style.formItemWrapper}>
                  <label
                    className={style.addReferralFormLabel}
                    style={{ fontWeight: "400" }}
                  >
                    Other Clinical Exam:
                  </label>
                  <div></div>
                  <input
                    className={style.winXpInputWrapper}
                    {...form.register("otherClinicalExam")}
                  />
                </div>
              </FormField>

              <PsaFormItem form={form} latestPsaResult={latestPsaResult} />

              <FormField name="resultOfUrinalysis">
                <div className={style.formItemWrapper}>
                  <label className={style.addReferralFormLabel}>
                    Result of Urinalysis:
                  </label>
                  <div></div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <input
                      style={{ flexGrow: 1 }}
                      className={style.winXpInputWrapper}
                      {...form.register("resultOfUrinalysis")}
                    />
                    <span style={{ fontSize: "12px" }}>
                      (to exclude infection)
                    </span>
                  </div>
                </div>
              </FormField>

              <ProstatePrevField
                name="hasPreviousBiopsy"
                label="Previous Prostate Biopsy:"
                form={form}
              />

              <FormField name="otherLabInvestigations">
                <div className={style.formItemWrapper}>
                  <label className={style.addReferralFormLabel}>
                    Other Lab Investigation:
                  </label>
                  <div></div>
                  <input
                    className={style.winXpInputWrapper}
                    {...form.register("otherLabInvestigations")}
                  />
                </div>
              </FormField>
              <FormField name="otherRadInvestigationsProstate">
                <div className={style.formItemWrapper}>
                  <label className={style.addReferralFormLabel}>
                    Rad Investigation:
                  </label>
                  <div></div>
                  <input
                    className={style.winXpInputWrapper}
                    {...form.register("otherRadInvestigationsProstate")}
                  />
                </div>
              </FormField>
            </form>
          </FormProvider>
        </div>
        <FormProvider {...form}>
          <CurrentMedicationSection form={form} />
        </FormProvider>
      </ItemFormWrapper>
    </>
  );
};
